"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _EventList_1 = require("./_EventList");
var _NotificationConfigurationFilter_1 = require("./_NotificationConfigurationFilter");
exports._QueueConfiguration = {
    type: "structure",
    required: ["QueueArn", "Events"],
    members: {
        Id: {
            shape: {
                type: "string"
            }
        },
        QueueArn: {
            shape: {
                type: "string"
            },
            locationName: "Queue"
        },
        Events: {
            shape: _EventList_1._EventList,
            locationName: "Event"
        },
        Filter: {
            shape: _NotificationConfigurationFilter_1._NotificationConfigurationFilter
        }
    }
};
//# sourceMappingURL=_QueueConfiguration.js.map